<template>
  <SpringCard
    class="wait-screen-loading-bar"
    :class="{'wait-screen-loading-bar--visible' : visible}"
  >
    <div class="wait-screen-loading-bar__content">
      <div class="wait-screen-loading-bar__animation">
        <LottiePlayer
          :animation-data="animationData"
        />
      </div>
      <span class="wait-screen-loading-bar__text">Your application is still being processed...</span>
    </div>
  </SpringCard>
</template>

<script>
import LottiePlayer from '@/components/common/lottie/LottiePlayer.vue'
import { SpringCard } from 'spring-ui'

export default {
  name: 'WaitScreenLoadingBarAwards',

  components: {
    LottiePlayer,
    SpringCard
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      animationData: require('@/assets/lottie/delay/loading-animation.json')
    }
  }

}
</script>

<style lang="scss" scoped>
.wait-screen-loading-bar {
  @apply min-h-0 py-15 px-20 mx-auto fixed left-[50%] z-50 opacity-0 top-[110px];

  transform: translate(-50%, -50%);
  transition: opacity 0.5s ease-in;
  width: calc(100% - 60px);

  @screen sm {
    @apply top-[140px];
  }

  @screen lg {
    width: calc(100% - 320px);
  }

  &--visible {
    @apply opacity-100;

    transition: opacity 0.5s ease-out;
  }

  &__content {
    @apply flex flex-row items-center;
  }

  &__animation {
    @apply h-50 w-50 mr-35;
  }
}
</style>
